import React, { Component } from 'react';
import PropTypes from 'prop-types';
import history from '../../app/history';
import { connect } from 'react-redux';
import { setNewToken, authenticateWithKeycloakToken } from '../../redux/actions/accountActions';
import { exchangeCodeForTokens, clearAuthMethodCache, isProfileIncompleteError, getRouteForRole } from './keycloakUtils';
import { appLogout } from '../../libs/utils';
import Loading from '../../custom/Loading';
import { get } from 'lodash';


class Callback extends Component {
  static propTypes = {
    setNewToken: PropTypes.func.isRequired,
    authenticateWithKeycloakToken: PropTypes.func.isRequired
  };

  componentDidMount() {
    this.handleCallback();
  }

  handleCallback = async () => {    
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const error = params.get('error');
    const isLogout = params.get('logout') === 'true';

    if (isLogout) {
      history.push('/login');
      return;
    }

    if (error) {
      history.push('/login');
      return;
    }

    if (!code) {
      history.push('/login');
      return;
    }
    
    try {
      const result = await exchangeCodeForTokens(code);

      try {
        // await verifyKeycloakToken(result.access_token);
      } catch (verificationError) {
        if (isProfileIncompleteError(verificationError)) {
          return;
        }

        appLogout();
        history.push('/');
        return;
      }

      clearAuthMethodCache();

      this.props.setNewToken(result.access_token);

      // Get user data including rol_id directly from the authentication response
      const authResponse = await this.props.authenticateWithKeycloakToken();
      const rolId = get(authResponse, 'account.rol_id');


      // Get the appropriate route based on user's role
      const route = getRouteForRole(rolId, result.access_token);
      history.push(route);
    } catch (err) {
      history.push('/login');
    }
  };

  render() {
    return <Loading center />;
  }
}

export default connect(null, {
  setNewToken,
  authenticateWithKeycloakToken
})(Callback);



// WEBPACK FOOTER //
// ./src/components/auth/Callback.js